// Tag.tsx

import React from "react";
import styles from "./InfoTag.module.css";

export enum TagVariant {
    DEFAULT = "default",
    ACTION_NEEDED = "actionNeeded",
    NOTICE = "notice",
    RSVP_DUE_SOON = "rsvpDueSoon",
    REJECTED = "rejected",
    DECLINED = "declined",
    CONFIRMED = "confirmed",
    IN_PROGRESS = "inProgress",
    ABANDONED = "abandoned",
    STATE_REPRESENTATION = "stateRepresentation",
    EXPIRED = "expired",
}

interface InfoTagProps {
    label: string;
    variant?: TagVariant;
}

const InfoTag: React.FC<InfoTagProps> = ({ label, variant = TagVariant.DEFAULT }) => {
    // Combine the base .tag class with a variant-specific class
    const className = `${styles.tag} ${styles[variant]}`;

    return <div className={className}>{label}</div>;
};

export default InfoTag;
